import Component from "./CourseFeedWrapperForPaidProgram";
export default Component;
